import React, { useState } from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import TermsCondition from './TermsCondition';
import './PrivacyTermsTab.css';

const PrivacyTermsTab = () => {
  const [activeTab, setActiveTab] = useState('privacy');

  return (
    <div id="privacyandterms" className="privacy-and-terms">
      <div className="privacy-and-terms-header">
        <div className="privacy-and-terms-tabs">
          <button
            className={`privacy-tab ${activeTab === 'privacy' ? 'active' : ''}`}
            onClick={() => setActiveTab('privacy')}
          >
            Terms & Conditions
          </button>

          <button
            className={`privacy-tab ${activeTab === 'terms' ? 'active' : ''}`}
            onClick={() => setActiveTab('terms')}
          >
            Cancellation Policy
          </button>
        </div>
      </div>

      <div className="privacy-tab-content">
        {activeTab === 'privacy' && <PrivacyPolicy />}
        {activeTab === 'terms' && <TermsCondition />}
      </div>
    </div>
  );
};

export default PrivacyTermsTab;
